import { Controller } from "@hotwired/stimulus"
import Project from "../models/project"

export default class extends Controller {
  static targets = ["results", "sort"];

  projects:Array <Project>;
  sortOrder:String

  connect () {
    this.sortOrder = this.sortTarget.value;
    this.createProjects();
  }

  sort(event) {
    if (this.sortOrder === this.sortTarget.value) {
      return;
    } else {
      this.sortOrder = this.sortTarget.value;
    }

    switch(this.sortOrder) {
      case "number":
        this.projects.sort((a:Project, b:Project) => {
          return b.id - a.id;
        });
        break;
      case "name":
        this.projects.sort((a:Project, b:Project) => {
          return a.name.localeCompare(b.name);
        });
        break;
      default:
        this.projects.sort((a:Project, b:Project) => {
          return a.index - b.index;
        });
    }
    this.updateProjectsList();
  }

  createProjects () {
    this.projects = [];
    const elements = this.element.querySelectorAll("a.job");

    for (var i = 0; i < elements.length; i++) {
      const project = new Project();
      project.element = elements[i] as HTMLElement;
      project.index = i;
      this.projects.push(project);
    }
  }

  updateProjectsList() {
    this.removeProjects();

    this.projects.forEach((project) => {
      this.resultsTarget.appendChild(project.element);
    });
  }

  removeProjects () {
    this.projects.forEach((project) => {
      if (project.element.parentElement !== null) {
        project.element.remove();
      }
    });
  }
}
